import React from 'react';
import DriverForm from './driverForm';
import { InfoIcon } from '../../icons';

const AddEditDriver = ({
  driversDetails,
  setOpenModal,
  handleAddMultipleDrivers,
  setSelectedDriver,
  mode = 'create',
}) => {
  return (
    <div className="container-sm mx-auto lg:py-10 py-5 flex flex-col items-center gap-y-5 max-lg:px-5">
      <div className="flex gap-3 lg:items-center flex-col w-full">
        <h3>{mode === 'edit' ? 'Επεξεργασία Στοιχείων' : 'Καταχώριση νέου οδηγού'}</h3>
        <div className="lg:px-6 py-3 flex justify-center items-center gap-3 bg-powdergrey rounded-xl">
          <InfoIcon />
          <div>
          <span className="text-body">
          Για μαζική καταχώριση οδηγών  {' '}
          </span>
          <button
            type="button"
            className="text-link text-primary"
            onClick={() => {
              setOpenModal(false);
              handleAddMultipleDrivers();
            }}
          >
             πάτησε εδώ
            </button>
            </div>
        </div>
      </div>
      {mode === 'create' ? (
        <DriverForm handleClose={() => setOpenModal(false)} />
      ) : (
        <DriverForm
          mode={mode}
          btnText="Αποθήκευση"
            driversDetails={driversDetails}
            setSelectedDriver={setSelectedDriver}
          handleClose={() => setOpenModal(false)}
        />
      )}
    </div>
  );
};

export default AddEditDriver;
